import gql from 'graphql-tag'

// NOTE: this calls the getActivityByUser2 api, not the original getActivityByUser
export default gql` 
query getActivityByUser($actDate: String, $username: String){
    getActivityByUser: getActivityByUser2(actDate: $actDate, username: $username ){
        items {
        id
        actDate
        username
        activityType
        value
        intensity
        notes
        timestamp
        }
    }
}`



// WEBPACK FOOTER //
// ./src/components/queries/GetActivityByUserQuery.js